import React from 'react';
import { IconProps } from './types';

export const EllipseIcon = (props: IconProps) => {
  const { size = 6, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 6 6'
    >
      <circle cx='3' cy='3' r='3' fill={color} />
    </svg>
  );
};
